export const candleBucket = (tsMs: number, tfMs: number): number =>
  Math.floor(tsMs / tfMs) * tfMs;

export const nextBucket = (lastBucket: number, tfMs: number): number =>
  lastBucket + tfMs;

export const shouldOpenFallback = (
  serverNow: number,
  nextBucketStart: number,
  graceMs: number,
  lastBucket: number,
): boolean =>
  serverNow >= nextBucketStart + graceMs && lastBucket < nextBucketStart;
